import { makeAutoObservable } from 'mobx'
import { queryClient } from '../../../../../App'
import { UTILS_KEYS } from '../api/api'
import { CategoriesResponse } from '../types/types'

class PaginationStore<T extends Record<string, any>> {
  page: number = 0
  size: number = 100
  totalSize: number = 0
  sort: string = '-id'
  params: T
  initParams: T
  selectedRow: any = null
  scrollHeight = 0

  constructor(initParams: T) {
    this.params = initParams
    this.initParams = initParams

    makeAutoObservable(this)
  }

  setPage = (page: number) => {
    if (page !== this.page) {
      this.setSelectedRow(null, 0)
    }

    this.page = page
  }

  setSize = (size: number) => {
    if (this.page !== 0) {
      this.setPage(0)
    }
    this.size = size
  }

  setTotalSize = (total: number) => {
    this.totalSize = total
  }

  setSort = (sort: string) => {
    this.setSelectedRow(null, 0)

    const isSame = this.sort?.endsWith(sort)
    const isReverse = isSame && this.sort?.startsWith('-')

    if (isSame) {
      this.sort = isReverse ? sort?.replace(/^-+/, '') : `-${sort}`
    } else {
      this.sort = sort
    }
  }

  setParams = (params: Partial<T>, savedParams?: Array<keyof T>) => {
    Object.keys(params).forEach((key) => {
      if (params[key as keyof T] && !savedParams?.includes(key as keyof T)) {
        if (key === 'categories') {
          this.params[key as keyof T] = getSelectedCategoryIds(
            params[key as keyof T] as boolean[],
          ) as T[keyof T]
        } else {
          this.params[key as keyof T] = params[key as keyof T] as T[keyof T]
        }
      }
    })

    Object.keys(this.params).forEach((key) => {
      if (
        this.params[key as keyof T] &&
        !savedParams?.includes(key as keyof T)
      ) {
        if (key === 'categories') {
          this.params[key as keyof T] = getSelectedCategoryIds(
            params[key as keyof T] as boolean[],
          ) as T[keyof T]
        } else {
          this.params[key as keyof T] = params[key as keyof T] as T[keyof T]
        }
      }
    })
  }

  setParam = (param: keyof T, value: any) => {
    if (param === 'categories') {
      this.params[param as keyof T] = getSelectedCategoryIds(
        value,
      ) as T[keyof T]
    } else {
      this.params[param] = value
    }
  }

  deleteParam = (param: keyof T) => {
    delete this.params[param]
  }

  setSelectedRow = (row: any, scrollHeight: number) => {
    this.selectedRow = row
    this.scrollHeight = scrollHeight
  }

  setScrollHeight = (scrollHeight: number) => {
    this.scrollHeight = scrollHeight
  }

  resetSelectedRow = () => {
    this.selectedRow = null
    this.scrollHeight = 0
  }

  resetParams = () => {
    this.params = { ...this.initParams }
    this.page = 0
    this.size = 100
    this.totalSize = 0
    this.sort = '-id'
  }
}

function getSelectedCategoryIds(
  selectedFlags: boolean[],
): (number | undefined)[] {
  const categories: CategoriesResponse | undefined =
    queryClient.getQueryData([UTILS_KEYS.GET_CATEGORIES]) ?? []

  // Проверка на одинаковую длину массивов
  if (categories?.length !== selectedFlags?.length) {
    console.warn('Длины массивов категорий и флагов не совпадают')
    return []
  }

  return categories.map((category: any) =>
    selectedFlags[category.id] ? category.id : undefined,
  ) // Берем только ID
}

export default PaginationStore
